import { render, staticRenderFns } from "./JobEconomicStateTable.vue?vue&type=template&id=a97c6294&scoped=true&"
import script from "./JobEconomicStateTable.vue?vue&type=script&lang=js&"
export * from "./JobEconomicStateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c6294",
  null
  
)

export default component.exports